import dayjs from 'dayjs';
import jwtDecode from 'jwt-decode';
import TokenStorage from '@/lib/token-storage';
import store from '../../store';

const isBypassMode = import.meta.env.VITE_BYPASS_MODE;

export const checkAuthentication = (to, _, next) => {
  let sessionValid = true;

  const token = TokenStorage.getToken();
  const loginPath = to.path.match(/\/auth\//gi);

  //Check if token exist
  if (token) {
    const decodedToken = jwtDecode(token);

    //Check if token is expired
    if (decodedToken.exp < dayjs().unix()) {
      sessionValid = false;
    }

    // check if user is already logged in & trying to access login page
    if (sessionValid && loginPath) {
      next({ name: 'app' });
      return false; // this will stop the execution of this function
    }
  }

  const userSessionValid = sessionValid && token;

  //Allow the user to access the login page if not logged in
  if (!userSessionValid && loginPath) {
    next();
    return false;
  }

  //If user is not logged in, redirect to login page
  if (!userSessionValid) {
    next({ name: 'login', query: { redirect: to.fullPath } });
    return false;
  }

  next();
};

export const checkPermissions = (to, _, next) => {
  if (store.state.authModule.disablePrivileges || isBypassMode) {
    return next();
  }

  if (to.matched.length > 0) {
    const matchedRoutes = to.matched.slice().reverse();
    const hasMeta = (match, key) =>
      Object.prototype.hasOwnProperty.call(match.meta, key);
    const foundModuleGuard = matchedRoutes.find(
      (match) =>
        hasMeta(match, 'requiredModuleAccess') || match.meta.requiresModuleAccess
    );

    if (foundModuleGuard) {
      const requiredModuleAccess =
        foundModuleGuard.meta.requiredModuleAccess ||
        foundModuleGuard.meta.app ||
        matchedRoutes.find((match) => match.meta.app)?.meta.app;
      const hasModuleAccess = store.getters['authModule/moduleAccess'](
        requiredModuleAccess
      );
      if (!hasModuleAccess) {
        return next({ name: 'no-module-access' });
      }
    }

    let foundRouteGuard = matchedRoutes.find((match) =>
      hasMeta(match, 'requiredPrivileges')
    );

    if (foundRouteGuard) {
      const hasAccess = store.getters['authModule/roleAccess'](
        foundRouteGuard.meta.requiredPrivileges,
        foundRouteGuard.meta.app
      );
      if (!hasAccess) {
        return next({ name: 'no-module-access' });
      }
    }
  }
  return next();
};
